import {mapGetters, mapState} from 'vuex';
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import VueCircle from 'vue2-circle-progress/src/index.vue'
import Vue from 'vue'
export default {
  name: 'quiz-format',
  components: {
    VueCircle
  },
  props: [],
  data() {
    return {
      fill: {
        color: "#0cbfe9"
      },
      quiz: {
        questions: []
      },
      questionIndex: 0,
      userResponses: [],
      quizResponses: [],
      quizStarted: true,
      isActive: false,
      totalTime: 90,
      totalScore: 0,
      countDown: {
        minutes: "00",
        seconds: "00"
      },
      quizType:'',
      quizTitle:'',
      questionIndexs: ['', 'A', 'B', 'C', 'D'],
      newArray: [],
      quizSubmitted: false,
      playScreenHeader:true,
    }
  },
  computed: {
    ...mapGetters([
      'pubQuizQListGetters',
    ]),
    getPubQuizDetails(){
      this.quiz.questions = this.$store.getters.pubQuizQListGetters.data
      return
    }
  },
  mounted() {
    this.quizType = this.$route.params.slug;
    if (this.quizType == 'space-science') {
      this.quizTitle = 'space Science'
    } else if (this.quizType == 'ai-and-machine-learning') {
      this.quizTitle = 'Machine Learning';
    } else if (this.quizType == 'finance') {
      this.quizTitle = 'Finance';
    } else if (this.quizType == 'computational-sciences') {
      this.quizTitle = 'Computational Sciences';
    } else if (this.quizType == 'computer-science') {
      this.quizTitle = 'computer science';
    }
    if(this.quiz.questions.length > 7){
      this.totalTime = 180
    }else{
      this.totalTime = 90 
    }
    var totalTime = new Date();
    totalTime.setSeconds(totalTime.getSeconds() + this.totalTime);
    this.initializeTimer(totalTime)
    $(document).ready(function(){
      $(".quizzort_popup_bg").addClass("quiz_play_screen")
    })
    this.getPubQuizDetails
    this.getCounter()
    this.renderMathJax()
  },
  methods: {
    renderMathJax(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('Next'));
        }
      },100)
    },
    getCounter() {
      let startIndex = this.questionIndex;
      let maxCount = 5;
      let maxQuestions = this.quiz.questions.length;
      let finalArray = [];
      let maxNumber = maxCount + startIndex;
      if (maxQuestions > 5) {
        for (let i = startIndex; i < maxNumber; i++) {
          finalArray.push(i + 1);
        }
        if (maxNumber <= maxQuestions)
          this.newArray = finalArray;
      } else {
        for (let i = 0; i < maxQuestions; i++) {
          finalArray.push(i + 1);
        }
        this.newArray = finalArray;
      }
    },
    selectOption: function(index, optionData, questionId) {
      // this.quizResponses.push({
      //   "options": optionData
      // })
      Vue.set(this.userResponses, this.questionIndex, index);
    },
    next: function() {
      if (this.questionIndex < this.quiz.questions.length) {
        this.questionIndex++;
        this.getCounter();
        this.renderMathJax()
        this.score()
        // this.renderMathJax()
      }if(this.questionIndex >= this.quiz.questions.length){
        this.playScreenHeader = false
        $(".quizzort_popup_bg").removeClass("quiz_play_screen")
      } 
    },
    prev: function() {
      this.renderMathJax()
      if (this.quiz.questions.length > 0) this.questionIndex--;
      // this.renderMathJax()
    },
    submitQuiz: function() {
      $('.quizloader').show();
      let data = this.quizResponses
      this.$store.dispatch('getpubQuizResultFun', data ).then(response => {
        if (response.status === 201) {
          this.quizSubmitted = true;
          this.totalScore = response.data.data.points_obtained;
          $('.quizloader').hide();
        }
      }).catch(err => {
        $('.quizloader').hide();
      })
    },
    // Return "true" count in userResponses
    // score: function(showScrore = false) {
    //   this.submitQuiz();
    // },
    score: function() {
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.quiz.questions[i].options[
            this.userResponses[i]
          ] !== "undefined" &&
          this.quiz.questions[i].options[this.userResponses[i]].is_correct
        ) {
          score = score + 1;
        }
      }
      this.totalScore = score;
      return score;
    },

    //   CountDown
    initializeTimer: function(endTime) {
      var _self = this;
      function updateClock() {
        let remainTime = _self.getTimeRemaining(endTime)
        _self.countDown = remainTime;
        _self.UpdatePercentage(remainTime.total);
        if (remainTime.total <= 0) {
          // _self.submitQuiz();
          clearInterval(timeinterval);
        }
      }
      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    },
    getTimeRemaining(endTime) {
      var t = Date.parse(endTime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      return {
        'total': t,
        'minutes': minutes,
        'seconds': seconds
      };
    },
    UpdatePercentage(remainTime) {
      if(remainTime == '0'){
        this.playScreenHeader = false
        $(".quizzort_popup_bg").removeClass("quiz_play_screen")
      }
      let totalTime = (this.totalTime) * 1000;
      let percentage = 100 - ((remainTime * 100) / totalTime)
      if (this.$refs.timerRef)
        this.$refs.timerRef.updateProgress(percentage);
    },
    showCategory() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizGameFinance', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500);
      localStorage.setItem('Explore_Course', 'second_banner');
      this.$router.push('/')
    },
    QuizGamePopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('showQuizGameFinance', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    }
  },
  beforeDestroy() {
    clearInterval(this.timeinterval);
  },
  beforeMount() {
    this.getPubQuizDetails;
  },
  watch:{
    getPubQuizDetails(){
      this.quiz.questions = this.$store.getters.pubQuizQListGetters.data
      return
    },
  }
}